import { useTranslation } from "react-i18next";

interface AttachmentsNoFilesMessageProps {
  attachmentType?: string;
}

export const AttachmentsNoFilesMessage = ({
  attachmentType,
}: AttachmentsNoFilesMessageProps) => {
  const { t } = useTranslation();

  const label = attachmentType
    ? `attachmentField.noFiles.${attachmentType}`
    : "attachmentField.noFiles";

  return (
    <div className="text-center py-1 text-gray-500">
      <p className="text-xs">{t(label)}</p>
    </div>
  );
};
